import { CheckCircle2, CircleDashed } from "lucide-react";
import { Loading, PageHead, useAdmin } from "./ui";
import { Automations } from "./Automations";
import { PayPalForm } from "./PayPalForm";
import { FreshaSettings } from "./FreshaSettings";
import { FeaturesCard } from "./Features";
import { MyAccount, NotificationEmail } from "./AccountCards";
import { InboundCard } from "./InboundCard";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { useOn } from "@/lib/features";

const Row = ({ ok, title, children, testId }) => (
  <div className="ad-card ad-setting" data-testid={testId}>
    {ok ? <CheckCircle2 size={20} color="#3d9a5b" /> : <CircleDashed size={20} color="#a87b17" />}
    <div><h3>{title}</h3><div className="muted-sm">{children}</div></div>
  </div>
);

export default function Settings() {
  const { data } = useAdmin("settings", "/admin/settings");
  const { data: me } = useQuery({ queryKey: ["me"], queryFn: () => api.get("/auth/me").then((r) => r.data), staleTime: 60_000 });
  const autoOn = useOn("automations");
  if (!data) return <Loading />;
  const pp = data.payments.paypal;
  return (
    <div data-testid="admin-settings">
      <PageHead eyebrow="Connections" title="Settings" />
      {me?.is_owner && <FeaturesCard />}
      <Row ok={pp.enabled} title={`PayPal & debit/credit cards ${pp.enabled ? `(connected · ${pp.mode})` : "— not connected"}`} testId="settings-paypal">
        {pp.enabled ? "Clients can pay their 50% deposit with PayPal or a debit/credit card." : "Add your PayPal Client ID and Secret below to turn on online deposits. Until then, confirmed bookings are saved as “Awaiting deposit” and you can record cash or bank transfer payments from Bookings."}
      </Row>
      <FreshaSettings />
      <PayPalForm />
      <Row ok={false} title="Bahamas merchant account (PowerTranz) — waiting for bank details" testId="settings-powertranz">
        When your bank (RBC, CIBC, Bank of the Bahamas) sends your PowerTranz Merchant ID and processing password, share them to switch on direct card payments.
      </Row>
      <NotificationEmail key={`notify-${data.booking_email}`} current={data.booking_email} from={data.email_from_name} />
      <InboundCard />
      {me && <MyAccount key={`me-${me.email}`} me={me} />}
      {autoOn ? <Automations /> : <Row ok={false} title="Automations are switched off" testId="settings-automations-off">Birthday, reminder and thank-you emails are paused. Switch Automations on under Features to restart them.</Row>}
    </div>
  );
}
